/**
 * Client-side mirror of the backend RECIPIENT_ACCOUNTS dict
 * (proptoken_backend/src/config/recipient-accounts.ts). Used for
 * resolving a `recipient_account_key` to a display label in the
 * standalone billings UI.
 *
 * Keep in sync with the backend file until the feature migrates
 * to a proper entity.
 */

export interface RecipientAccount {
  key: string
  label: string
  bank: number
  bank_name: string
  branch: string
  account: string
  beneficiary_name: string
  beneficiary_document: string
}

export const RECIPIENT_ACCOUNTS: Record<string, RecipientAccount> = {
  itau_main: {
    key: 'itau_main',
    label: 'Itaú — Conta principal',
    bank: 341,
    bank_name: 'Itaú',
    branch: '0000',
    account: '00000-0',
    beneficiary_name: 'PropToken Demo',
    beneficiary_document: '00.000.000/0001-00'
  }
}

export const getRecipientAccountLabel = (key: string): string => {
  return RECIPIENT_ACCOUNTS[key]?.label || key
}
